export const GET_REQUIRED_COMPETENCIES = 'GET_REQUIRED_COMPETENCIES';
export const GET_REQUIRED_COMPETENCIES_SUCCESS = `${GET_REQUIRED_COMPETENCIES}/SUCCESS`;
export const GET_REQUIRED_COMPETENCIES_FAILURE = `${GET_REQUIRED_COMPETENCIES}/FAILURE`;

export default {
  GET_REQUIRED_COMPETENCIES,
  GET_REQUIRED_COMPETENCIES_SUCCESS,
  GET_REQUIRED_COMPETENCIES_FAILURE
};
